import { configureStore } from '@reduxjs/toolkit';

import cabinListApp from '../reducers/cabinList';

// `common` is the host-page state object seeded through `preloadedState`. `devTools` is dev-only;
// dev checks stay on.
export const createCabinListStore = (common) =>
  configureStore({
    reducer: cabinListApp,
    preloadedState: { common },
    devTools: process.env.NODE_ENV !== 'production',
  });
